import React from 'react';
import { Link } from 'react-router-dom';
import SubNavbar from '../../components/SubNavbar';
import ContactBox from '../../components/ContactBox';

const Writings = () => {
  return (
    <div className="white-page">
      <SubNavbar />
      <ContactBox />
      
      <div className="page-content-wrapper">
        <div className="photo-collections">
          {/* <Link to="/writings/blog-post-1" className="photo-location">
            September 2025 <span className="blog-arrow">→</span> <span className="blog-content">Blog Post 1</span>
          </Link> */}
          <Link to="/writings/bcis" className="photo-location">
            May 2025 <span className="blog-arrow">→</span> <span className="blog-content">My introduction to BCIs</span>
          </Link>
          <div className="writings-placeholder">
            <em>September 2025: It's empty here now, but expect more in the coming months!</em>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Writings;
